var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40326 0.964647C2.00598 0.567367 1.36187 0.567367 0.964586 0.964647C0.567306 1.36193 0.567306 2.00605 0.964586 2.40333L3.61393 5.05267C4.12674 5.57782 4.12821 6.41602 3.61834 6.94296L0.964586 9.59671C0.567306 9.994 0.567306 10.6381 0.964586 11.0354C1.36187 11.4327 2.00598 11.4327 2.40326 11.0354L5.04091 8.39775C5.56673 7.87192 6.417 7.8682 6.94758 8.38632L9.59665 11.0354C9.99393 11.4327 10.6381 11.4327 11.0353 11.0354C11.4326 10.6381 11.4326 9.994 11.0353 9.59671L8.39789 6.95927C7.86818 6.42956 7.86825 5.57067 8.39796 5.04096L11.0353 2.40333C11.4326 2.00605 11.4326 1.36193 11.0353 0.964647C10.6381 0.567367 9.99393 0.567367 9.59665 0.964647L6.943 3.6183C6.41213 4.13197 5.56533 4.12665 5.04101 3.60232L2.40326 0.964647Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconWhite);
export default __webpack_public_path__ + "static/media/close-icon-white.b455a3b2fe8ebc5987f810d2b9f153e8.svg";
export { ForwardRef as ReactComponent };